module.exports = __webpack_public_path__ + "static/media/icon_alert_mob_2x.fbd384fd.png";